import { render, staticRenderFns } from "./invalidCustomer.vue?vue&type=template&id=c5a562b6&scoped=true"
import script from "./invalidCustomer.vue?vue&type=script&lang=js"
export * from "./invalidCustomer.vue?vue&type=script&lang=js"
import style0 from "./invalidCustomer.vue?vue&type=style&index=0&id=c5a562b6&prod&lang=less"
import style1 from "./invalidCustomer.vue?vue&type=style&index=1&id=c5a562b6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5a562b6",
  null
  
)

export default component.exports